import React, { useState, useEffect, useRef } from "react";
import styles from "./profile-card.module.css";
import { useRoot } from "../../../context/RootContext";
import { useTour } from "../../../context/TourContext";
import ProfileIcon from "../../../assets/profile/User_default.svg";
import LogoutBtn from "../../../assets/profile/logout.svg";
import PrivacyBtn from "../../../assets/profile/privacy.svg";
import { useNavigate } from "@remix-run/react";
import {
  getCookie,
  removeCookie,
  setCookie } from
"../../../utils/TutorConstants";
import {
  isNotEmptyOrNull,
  tutorString,
  urlString } from
"../../../utils/common-utils";
import EditButton from "../../../assets/svgs/editButton.svg";
import ProfileWallIcon from "../../../assets/profile/profileWallIcon.svg";
import ProfileExperientialIcon from "../../../assets/profile/experimentIcon.svg";
import ProfileProductIcon from "../../../assets/profile/productIcon.svg";
import ProfileSettingsIcon from "../../../assets/profile/settingsIcon.svg";
import ReportIssueIcon from "../../../assets/svgs/reportIssueIcon.svg";
import { logoutUser, reportIssue } from "../../../api/login-service";
import { useToast } from "@chakra-ui/react";
import { status } from "../../../utils/LearningPathUtils";
import { StorageService } from "../../../utils/StorageUtils";
import RESOURCES from "../../../resourses/RESOURCES";
import { ProfileTour } from "../../../pages/task/ProfileTour";
import useStateRef from "react-usestateref";
import timeLogsDB from "../../../utils/TimeLogsDB";

export default function ProfileTopMenu() {
  const {
    openProfileMenu,
    setOpenEditProfile,
    setOpenProfileMenu,
    setIsLogout,
    profileIconRef,
    selectedIndex,
    setIsAuthenticated,
    isTutor,
    isStandalone,
    displayProductTour,
    setDisplayProductTour,
    isUpdatesDisplayed
  } = useRoot();
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const [userDetails, setUserDetails] = useState({});
  const [isEditOption, setIsEditOption] = useState(false);
  const [isDemo, setIsDemo, isDemoRef] = useStateRef(false);
  const toast = useToast();
  const { setTourState } = useTour();
  useEffect(() => {
    setUserDetails({});
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    if (details) {
      setUserDetails(details);
    }
    const isDemoRun = getCookie("IsDemo") === "true";
    setIsDemo(isDemoRun);
  }, [openProfileMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      !profileIconRef?.current?.contains(event?.target))
      {
        setOpenProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openProfileMenu]);

  const formatGrade = (gradeName) => {
    // Assuming the grade is stored in the format "Grade X" or just "X"
    const grade = gradeName?.replace(/\D/g, ""); // Remove all non-digit characters
    if (!grade) return gradeName; // Return original string if no digits found
    return `${grade}th Grade`; // Append "th Grade" to the digit
  };
  const handleShowToast = (status, type) => {
    toast({
      position: "top",
      description: status,
      status: type,
      duration: 1500,
      isClosable: true,
      containerStyle: {
        color: "#fff"
      }
    });
  };

  // const syncTimeLogs = async () => {
  //   try {
  //     const timeLogsData = await timeLogsDB.getAllTimeLogs();
  //     if (timeLogsData && timeLogsData.length > 0) {
  //       await postTimeLogs(timeLogsData);
  //     }
  //   } catch (error) {
  //     console.error("Error syncing time logs:", error);
  //   }
  //   timeLogsDB.clearAllTimeLogs();
  // };

  const handleLogout = async (event) => {
    // syncTimeLogs();
    setIsLogout(true);
    setTourState({
      enabled: true,
      currentStep: 0,
      showProfileStep: false
    });
    let { success, data, errorMessage } = await logoutUser();
    if (success) {

      //let { success, data, errorMessage } = data || {};
    } else {console.log(errorMessage, "Logout API failed");
    }
    timeLogsDB.clearAllTimeLogs();
    handleShowToast("Logout successful!", status.success);
    setIsAuthenticated(false);
    event.stopPropagation();
    setOpenProfileMenu(false);
    StorageService.clear();
    if (isNotEmptyOrNull(getCookie("schoolName"))) {
      setCookie("studentId", "");
      setCookie("isEdit", false);
      navigate(`${urlString}/student/` + getCookie("schoolName"), {
        replace: true
      });
    } else {
      let selectedItems = getCookie("selectedDemoItems");
      if (isNotEmptyOrNull(selectedItems)) {
        selectedItems = JSON.parse(selectedItems);
      }
      if (selectedItems?.length > 0) {
        window.location.href = `${window?.ENV?.BROWSER_URL}/demoProfiles`;
      } else {
        setCookie("schoolId", "");
        navigate(`${isTutor ? tutorString : urlString}/login`, {
          replace: true
        });
      }
    }
  };

  const handleWallClick = () => {
    setOpenProfileMenu(false);
    navigate(`${urlString}/wall`);
  };

  const handleExperientialClick = () => {
    setOpenProfileMenu(false);
    navigate(`${urlString}/wall/my-class-wall`);
  };

  const handleProductClick = () => {
    //console.log("handle Product Click");
    setOpenProfileMenu(false);
    setDisplayProductTour(true);
    setTourState({
      enabled: true,
      currentStep: 0,
      showProfileStep: false
    });
  };

  const handleSettingsClick = () => {
    //console.log("handle Settings Click");
    setOpenProfileMenu(false);
  };

  const handleEditProfile = () => {
    setOpenProfileMenu(false);

    setCookie("isEdit", true);
    navigate(`${urlString}/onboarding`, {
      replace: true
    });
    //navigate(`${urlString}/profile`);
    // setOpenEditProfile(true);
  };

  const handleReportIssue = async () => {
    const success = await reportIssue();
    if (success) {
      handleShowToast("Issue reported Successfully", status.warning);
    }
  };
  const handleNavigate = (path) => {
    setOpenProfileMenu(false);
    navigate(path);
  };
  if (!openProfileMenu) return null;

  const getUserProfileImage = () => {
    let profile = isNotEmptyOrNull(userDetails?.onBoardingDetails?.Avatar) ?
    userDetails?.onBoardingDetails?.Avatar?.includes("boy") ?
    RESOURCES.images.three_boy?.[
    parseInt(
      userDetails?.onBoardingDetails?.Avatar?.replace("boy_", ""),
      10
    )] :

    RESOURCES.images.three_girl?.[
    parseInt(
      userDetails?.onBoardingDetails?.Avatar?.replace("girl_", ""),
      10
    )] :

    ProfileIcon;
    return profile;
  };

  const handleStep6 = (open) => {
    setOpenProfileMenu(open);
  };

  return (
    <>
      {displayProductTour && <ProfileTour onStep6={handleStep6} />}
      <div
        id="introProfile"
        className={styles["profile-menu"]}
        ref={menuRef}
        style={displayProductTour ? { pointerEvents: "none" } : {}}>

        <div className={styles["profile-container"]}>
          <div className={styles["profile-icons"]}>
            <img
              className={styles["profile-img"]}
              src={getUserProfileImage()}
              alt="Profile" />

            <img
              className={styles["edit-icon-img"]}
              src={EditButton}
              alt="Edit Icon"
              onClick={handleEditProfile} />

          </div>
          <div
            className={styles["profile-name"]}>
            {`${userDetails.firstName} ${userDetails.lastName}`}</div>
          <div className={styles["profile-grade"]}>
            {`${formatGrade(userDetails.grade_name)}${
            userDetails.sectionName ? ` - ${userDetails.sectionName}` : ""}`
            }
          </div>
        </div>

        {/* {!isStandalone && (
          <div className={styles["profile-list"]} onClick={handleWallClick}>
           <img
             className={styles["profile-list-img"]}
             src={ProfileWallIcon}
             alt="Profile Wall Icon"
           />
           <div className={styles["profile-list-text"]}>Wall</div>
          </div>
          )} */}
        {selectedIndex !== 3 && selectedIndex !== 2 && !isStandalone &&
        <div
          className={styles["profile-list"]}
          onClick={handleExperientialClick}>

            <img
            className={styles["profile-list-img"]}
            src={ProfileExperientialIcon}
            alt="Profile Experiential Icon" />

            <div className={styles["profile-list-text"]}>Experiential Hub</div>
          </div>
        }
        {!isStandalone &&
        location?.pathname?.includes("home") &&
        !isUpdatesDisplayed &&
        <div
          className={styles["profile-list"]}
          onClick={handleProductClick}>

              <img
            className={styles["profile-list-img"]}
            src={ProfileProductIcon}
            alt="Profile Product Icon" />

              <div className={styles["profile-list-text"]}>Product Tour</div>
            </div>
        }
        {isStandalone &&
        <div
          className={styles["profile-list"]}
          onClick={() => {
            handleNavigate("/sme/subject-specific-rules");
          }}>

            <img
            className={styles["profile-list-img"]}
            src={ProfileWallIcon}
            alt="Profile Wall Icon" />

            <div className={styles["profile-list-text"]}>
              Subject Specific Rules
            </div>
          </div>
        }
        {isStandalone &&
        <div
          className={styles["profile-list"]}
          onClick={() => {
            handleNavigate("/sme/practice-by-questionid");
          }}>

            <img
            className={styles["profile-list-img"]}
            src={ProfileWallIcon}
            alt="Profile Wall Icon" />

            <div className={styles["profile-list-text"]}>
              Practice By QuestionID
            </div>
          </div>
        }
        {!isStandalone &&
        <div className={styles["profile-list"]} onClick={handleSettingsClick}>
            <img
            className={styles["profile-list-img"]}
            src={ProfileSettingsIcon}
            alt="Profile Settings Icon" />

            <div className={styles["profile-list-text"]}>Settings</div>
          </div>
        }
        {!isStandalone &&
        <div className={styles["profile-list"]} onClick={handleReportIssue}>
            <img
            className={styles["profile-list-img"]}
            src={ReportIssueIcon}
            alt="Profile Settings Icon" />

            <div className={styles["profile-list-text"]}>Report Issue</div>
          </div>
        }
        <div
          className={styles["profile-list"]}
          onClick={() => {
            handleNavigate(`${urlString}/privacy`);
          }}>

          <img
            className={styles["profile-list-img"]}
            src={PrivacyBtn}
            alt="Privacy" />

          <div className={styles["profile-list-text"]}>Privacy Policy </div>
        </div>
        <div className={styles["logout-btn-container"]} onClick={handleLogout}>
          <img className={styles["logout-btn"]} src={LogoutBtn} alt="Logout" />
          <div className={styles["profile-list-text"]}>Log Out</div>
        </div>
      </div>
    </>);

}